export default __webpack_public_path__ + "static/media/monkey.1564b590.png";